'use client';
import CssBaseline from '@mui/material/CssBaseline';
import { Route, RouterProvider, Routes, createBrowserRouter } from 'react-router-dom';
import AfterSales from './pages/afterSales';
import ReturnList from './pages/afterSales/returnList';
import NotFound from './pages/notFound';
import OrderCancelSuccess from './pages/order/orderCancelSuccess';
import OrderDetail from './pages/order/orderDetail';
import OrderList from './pages/order/orderList';
import Customise from './pages/settings/customise';

import { getUserUUIDFromCookie } from '@/utils/userUtils';
import { applySnapshot } from 'mobx-state-tree';
import { useEffect } from 'react';
import { useStores } from './models';
import Profile from './pages/profile';
import ShippingAddress from './pages/profile/address';
import InvitePolitelyPage from './pages/profile/invite-a-friend';
import ProfileList from './pages/profile/profileList';
import Reviews from './pages/profile/reviews';
import WaitingReviewDetail from './pages/profile/reviews/WaitingReviewDetail';
import ReviewResult from './pages/profile/reviews/reviewResult';
import Voucher from './pages/profile/voucher';
import Points from './pages/profile/points';
import WishList from './pages/profile/wishList';

const Root = () => {
  useEffect(() => {
    getUserUUIDFromCookie();
  }, []);

  return (
    <CssBaseline>
      <Routes>
        {/* 语言设置 */}
        <Route
          path='/settings/customise'
          element={
            <>
              <Customise />
            </>
          }
        />
        {/* 订单详情 */}
        <Route path='/profile/my-orders/order-details' element={<OrderDetail />} />
        {/* 取消成功页面 */}
        <Route
          path='/order-cancelled'
          element={
            <>
              <OrderCancelSuccess />
            </>
          }
        />
        {/* 售后详情 */}
        <Route path='/my-orders/refund' element={<AfterSales />} />

        {/* 个人中心 */}
        <Route path='/profile' element={<Profile />} />
        <Route element={<ProfileList />}>
          {/* 订单 */}
          <Route path='/profile/my-orders' element={<OrderList />} />
          {/* 售后单列表 */}
          <Route path='/profile/my-returns' element={<ReturnList />} />
          {/* 心愿单 */}
          <Route path='/profile/wishlist' element={<WishList />} />
          {/* 收货地址 */}
          <Route path='/profile/my-address' element={<ShippingAddress />} />
          {/* 优惠券列表 */}
          <Route path='/profile/coupons-discounts' element={<Voucher />} />
          {/* 评论列表 */}
          <Route path='/profile/my-reviews' element={<Reviews />} />
          {/* 积分 */}
          <Route path='/profile/points-activity' element={<Points />} />
        </Route>
        {/* 评论详情 */}
        <Route path='/Review' element={<WaitingReviewDetail />} />
        {/* 评论结果页面 */}
        <Route path='/ReviewResult' element={<ReviewResult />} />
        {/* 优惠券列表 */}
        <Route path='/profile/coupons-discounts' element={<Voucher />} />
        {/* 邀请有礼 */}
        <Route path='/profile/invite-a-friend' element={<InvitePolitelyPage />} />

        <Route path='*' element={<NotFound />} />
      </Routes>
    </CssBaseline>
  );
};

const router = createBrowserRouter([{ path: '*', element: <Root /> }]);
export default function App() {
  const { orderStore } = useStores();
  try {
    const orderStoreData = JSON.parse(sessionStorage.getItem('orderStore') as string);
    if (orderStoreData) {
      applySnapshot(orderStore, orderStoreData);
      sessionStorage.removeItem('orderStore');
    }
  } catch (error) {
    console.log(error);
  }

  return <RouterProvider router={router} />;
}
